// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1aaa629b","209":"450a0ebe","787":"ef0a8cc5"}[chunkId] + ".chunk.js";
};